import { UnstyledLink, UnstyledLinkProps } from '@sparemin/blockhead';
import * as React from 'react';
import PlaybackAwareCta from 'components/PlaybackAwareCta';
import { usePlayback } from 'components/Player';
import usePreparePlayDestinationUrl from './usePreparePlayDestinationUrl';

const INTERACTION_PROPS: Array<keyof UnstyledLinkProps<'a'>> = ['onPress'];

export type PlaybackAwareDestinationLinkProps<
  As extends React.ElementType = 'a',
> = UnstyledLinkProps<As>;

function PlaybackAwareDestinationLink<As extends React.ElementType = 'a'>(
  props: PlaybackAwareDestinationLinkProps<As>,
) {
  const { onPress } = props;
  const { player } = usePlayback();

  const { anchorProps } = usePreparePlayDestinationUrl({
    onPress,
    player,
  });

  return (
    <PlaybackAwareCta interactionProps={INTERACTION_PROPS}>
      <UnstyledLink {...props} {...anchorProps} />
    </PlaybackAwareCta>
  );
}

export default PlaybackAwareDestinationLink;
